import React from 'react'
import {createRoot} from 'react-dom/client'
import {App} from './components/App'
import './types.d.ts'
import Konva from 'konva'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(React.createElement(App))
